import { useState } from "react";
import { Modal } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import featureLoading from "../assets/images/feature-loading.png";
import mask from "../assets/images/feature-modal-mask.png";

const FeatureComingSoon = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const handleCancel = () => {
    setOpen();
  };

  return (
    <>
      <div onClick={() => setOpen(true)}>{children}</div>
      {isOpen && (
        <Modal
          title=""
          open={isOpen}
          centered
          destroyOnClose
          width={400}
          className="delete-popup"
          footer={null}
          onOk={handleCancel}
          onCancel={handleCancel}
          styles={{
            mask: {
              background: `url(${mask}) no-repeat center center`,
              backgroundSize: "80% 70%",
              backgroundColor: "rgba(0, 0, 0, 0.70)",
              backdropFilter: "blur(10px)",
            },
          }}
        >
          <div className="d-flex flex-column align-items-center overflow-hidden">
            <div style={{ padding: 20 }}>
              <img src={featureLoading} alt="" height={265} />
            </div>
            <div
              className="bg-theme text-center py-20"
              style={{
                width: "100%",
                borderBottomLeftRadius: 6,
                borderBottomRightRadius: 6,
              }}
            >
              <p className="heading24px fw-bold  text-white">
                The Future is Loading…
              </p>
              <p className="d-flex align-items-center justify-content-center">
                <span
                  className="fw-normal text-white"
                  style={{ maxWidth: 300 }}
                >
                  A powerful new feature is <strong>coming soon</strong> to
                  level up your experience. Stay tuned!
                </span>
              </p>
              <div
                style={{ gap: 10 }}
                className="text-white cursor-pointer mt20 fw-bold mb20 heading13px d-flex align-items-center justify-content-center"
                onClick={handleCancel}
              >
                <ArrowLeftOutlined className="fw-bold heading12px" />
                Go Back
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FeatureComingSoon;
